import React, { useEffect, useState } from 'react'
import { FaChevronRight, FaCheck } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { Noorderhistory } from '../image';
import { orderhistory, haveAnIssue } from '../services/User-service';
import Footer from '../components/footer';
import Loader from "../components/Loader";
import { formatPrice } from "../utils/formatPrice";
import { toast } from 'react-toastify';

import { logout } from '../Redux/features/User/userSlice';
import { BrowserView, MobileView } from 'react-device-detect';

function formatOrderDate(value) {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });
}

function getProductListStatus(product) {
    return product?.status || '—';
}

function getProductImage(product) {
    return product?.product_thumbail || product?.cover_image || product?.image || '';
}

function isGiftItem(item) {
    return !!(item?.gift_id || item?.giftcard_id || item?.is_gift || item?.type === 'gift');
}

function getIssueItems(order) {
    const productList = Array.isArray(order?.productslist) ? order.productslist : [];
    const giftList = [
        ...(Array.isArray(order?.giftlist) ? order.giftlist : []),
        ...(Array.isArray(order?.gift_list) ? order.gift_list : []),
        ...(Array.isArray(order?.giftcards) ? order.giftcards : []),
        ...(Array.isArray(order?.gifts) ? order.gifts : []),
    ];

    const fromProducts = productList.map((item, index) => ({
        ...item,
        _issueType: isGiftItem(item) ? 'gift' : 'product',
        _issueKey: isGiftItem(item)
            ? `gift-${item.gift_id || item.id || index}`
            : `product-${item.product_id || item.id || index}`,
    }));

    const existingGiftIds = new Set(
        fromProducts
            .filter((item) => item._issueType === 'gift')
            .map((item) => String(item.gift_id || item.id || ''))
    );

    const fromGifts = giftList
        .filter((item) => {
            const giftId = String(item?.gift_id || item?.id || '');
            return giftId && !existingGiftIds.has(giftId);
        })
        .map((item, index) => ({
            ...item,
            _issueType: 'gift',
            _issueKey: `gift-${item.gift_id || item.id || index}`,
            product_title: item.product_title || item.gift_title || item.title || 'Gift Card',
            product_thumbail: item.product_thumbail || item.gift_image || item.image || item.cover_image,
        }));

    return [...fromProducts, ...fromGifts];
}

function AccountSidebar({ onLogout }) {
    return (
        <div className="h5 optionListLineHeight xs3 layout column orat-dark-grey-color">
            <Link to="/myaccount" className="cursor-pointer demi-bold orat-black-color"> PERSONAL DETAILS </Link>
            <Link to="/orderhistory" className="cursor-pointer demi-bold orat-color"> ORDER HISTORY </Link>
            <Link to="/addaddress" className="cursor-pointer demi-bold orat-black-color"> MANAGE ADDRESSES </Link>
            <Link to="/wishlist" className="cursor-pointer demi-bold orat-black-color"> MY WISHLIST </Link>
            <Link onClick={onLogout} className="cursor-pointer demi-bold orat-black-color"> LOGOUT </Link>
        </div>
    );
}

const ISSUE_OPTIONS = [
    { id: 'where', label: 'Where is my order?' },
    { id: 'exchange', label: 'I want to exchange an item.' },
    { id: 'other', label: 'My issue is not listed here.' },
];

const EXCHANGE_REASONS = [
    "I don't like the fit.",
    "I don't like the quality of the product.",
    'Product color is not matching with the website.',
    'Product design is not matching with the website.',
];

function OrderIssueProductSummary({ products }) {
    if (!products.length) return null;

    return (
        <div className="OrderIssuePopupSummaryList">
            {products.map((product, index) => (
                <div
                    className="OrderIssuePopupSummary"
                    key={`issue-summary-${product?._issueKey || product?.product_id || product?.gift_id || product?.sku || index}`}
                >
                    <div className="OrderIssuePopupSummaryThumb">
                        <img
                            src={getProductImage(product)}
                            alt={product?.product_title || 'Product'}
                        />
                    </div>
                    <div className="OrderIssuePopupSummaryDetails">
                        <div className="OrderIssuePopupSummaryTitle">{product?.product_title}</div>
                        {product?.sku ? (
                            <div className="OrderIssuePopupSummaryLine">SKU Code : {product.sku}</div>
                        ) : null}
                        {product?.size ? (
                            <div className="OrderIssuePopupSummaryLine">Size : {product.size}</div>
                        ) : null}
                        {product?._issueType === 'gift' ? (
                            <div className="OrderIssuePopupSummaryLine">Gift Card</div>
                        ) : null}
                    </div>
                    <div className="OrderIssuePopupSummaryPrice">
                        ₹ {formatPrice(
                            product?.saleprice > 0 ? product.saleprice : product?.price,
                            { showSymbol: false }
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
}

function OrderIssuePopup({ show, order, onClose, onIssueReported }) {
    const issueItems = getIssueItems(order);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [step, setStep] = useState('products');
    const [selectedReason, setSelectedReason] = useState('');
    const [confirmTitle, setConfirmTitle] = useState('');
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (show) {
            setSelectedKeys([]);
            setStep('products');
            setSelectedReason('');
            setConfirmTitle('');
            setSubmitting(false);
        }
    }, [show, order?.order_number]);

    const selectedProducts = selectedKeys
        .map((key) => issueItems[key])
        .filter(Boolean);

    const toggleProduct = (index) => {
        setSelectedKeys((prev) =>
            prev.includes(index) ? prev.filter((key) => key !== index) : [...prev, index]
        );
    };

    const submitIssue = async (haveAnIssueValue, title) => {
        if (!order || selectedProducts.length === 0 || submitting) return;

        const orderId = order.id || order.order_id;
        if (!orderId) {
            toast.error('Order id missing. Please try again.', { position: 'bottom-right' });
            return;
        }

        const productsPayload = selectedProducts
            .filter((item) => item._issueType !== 'gift')
            .map((product) => ({
                product_id: Number(product.product_id || product.id),
                have_an_issue: haveAnIssueValue,
                status: 'Issue Reported',
            }))
            .filter((item) => !Number.isNaN(item.product_id));

        const giftsPayload = selectedProducts
            .filter((item) => item._issueType === 'gift')
            .map((gift) => ({
                gift_id: Number(gift.gift_id || gift.giftcard_id || gift.id),
                have_an_issue: haveAnIssueValue,
                status: 'Issue Reported',
            }))
            .filter((item) => !Number.isNaN(item.gift_id));

        if (productsPayload.length === 0 && giftsPayload.length === 0) {
            toast.error('Please select a valid product or gift card.', { position: 'bottom-right' });
            return;
        }

        setSubmitting(true);
        try {
            const payload = {
                order_id: orderId,
            };
            if (productsPayload.length > 0) {
                payload.products = productsPayload;
            }
            if (giftsPayload.length > 0) {
                payload.gifts = giftsPayload;
            }

            await haveAnIssue(payload);

            if (typeof onIssueReported === 'function') {
                onIssueReported({
                    orderId,
                    productIds: productsPayload.map((item) => item.product_id),
                    giftIds: giftsPayload.map((item) => item.gift_id),
                    status: 'Issue Reported',
                });
            }

            setConfirmTitle(title);
            setStep('confirm');
        } catch (error) {
            console.error('Error submitting have an issue:', error);
            toast.error(
                error?.response?.data?.message || 'Unable to submit issue. Please try again.',
                { position: 'bottom-right' }
            );
        } finally {
            setSubmitting(false);
        }
    };

    const handleProductSubmit = () => {
        if (selectedKeys.length === 0 || !order) return;
        setStep('options');
    };

    const handleIssueOption = (option) => {
        if (option.id === 'exchange') {
            setSelectedReason('');
            setStep('exchange');
            return;
        }
        submitIssue(option.label, option.label);
    };

    const handleReasonSubmit = () => {
        if (!selectedReason) return;
        const haveAnIssueValue = `I want to exchange an item. - ${selectedReason}`;
        submitIssue(haveAnIssueValue, 'I want to exchange an item.');
    };

    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            className="OrderIssuePopupModal"
            dialogClassName="OrderIssuePopupDialog"
            contentClassName="OrderIssuePopupContent"
        >
            <div className={`OrderIssuePopup${step !== 'products' ? ' OrderIssuePopup--detail' : ''}`}>
                <button type="button" className="OrderIssuePopupClose" onClick={onClose} aria-label="Close">
                    <IoClose size={22} />
                </button>

                <div className="OrderIssuePopupHeader">
                    <div className="OrderIssuePopupOrderId">ORDER ID : {order?.order_number}</div>
                    <div className="OrderIssuePopupDate">{formatOrderDate(order?.created_at)}</div>
                </div>

                {step === 'products' ? (
                    <>
                        <div className="OrderIssuePopupBody">
                            <p className="OrderIssuePopupHint">Select the product with the issue from your order</p>

                            <div className="OrderIssuePopupProducts">
                                {issueItems.map((product, index) => {
                                    const isSelected = selectedKeys.includes(index);
                                    return (
                                        <button
                                            type="button"
                                            key={`${order?.order_number || 'order'}-issue-${product._issueKey || index}`}
                                            className={`OrderIssuePopupProduct${isSelected ? ' is-selected' : ''}`}
                                            onClick={() => toggleProduct(index)}
                                            aria-pressed={isSelected}
                                        >
                                            <img
                                                src={getProductImage(product)}
                                                alt={product.product_title || 'Product'}
                                            />
                                            {isSelected ? (
                                                <span className="OrderIssuePopupProductTick" aria-hidden="true">
                                                    <FaCheck size={10} />
                                                </span>
                                            ) : null}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>

                        <div className="OrderIssuePopupFooter">
                            <button
                                type="button"
                                className="OrderIssuePopupSubmit"
                                onClick={handleProductSubmit}
                                disabled={selectedKeys.length === 0}
                            >
                                SUBMIT
                            </button>
                        </div>
                    </>
                ) : null}

                {step === 'options' ? (
                    <div className="OrderIssuePopupBody OrderIssuePopupBody--flush">
                        <OrderIssueProductSummary products={selectedProducts} />
                        <div className="OrderIssuePopupOptions">
                            {ISSUE_OPTIONS.map((option) => (
                                <button
                                    type="button"
                                    key={option.id}
                                    className="OrderIssuePopupOption"
                                    onClick={() => handleIssueOption(option)}
                                    disabled={submitting}
                                >
                                    <span>{option.label}</span>
                                    <FaChevronRight size={12} />
                                </button>
                            ))}
                        </div>
                    </div>
                ) : null}

                {step === 'exchange' ? (
                    <>
                        <div className="OrderIssuePopupBody OrderIssuePopupBody--flush">
                            <OrderIssueProductSummary products={selectedProducts} />
                            <div className="OrderIssuePopupReasonBlock">
                                <p className="OrderIssuePopupHint">
                                    Tell us why you want to exchange the item.
                                </p>
                                <div className="OrderIssuePopupReasons">
                                    {EXCHANGE_REASONS.map((reason) => {
                                        const isChecked = selectedReason === reason;
                                        return (
                                            <label
                                                key={reason}
                                                className={`OrderIssuePopupReason${isChecked ? ' is-selected' : ''}`}
                                            >
                                                <input
                                                    type="radio"
                                                    name="issue-exchange-reason"
                                                    value={reason}
                                                    checked={isChecked}
                                                    onChange={() => setSelectedReason(reason)}
                                                />
                                                <span className="OrderIssuePopupReasonRadio" aria-hidden="true" />
                                                <span className="OrderIssuePopupReasonText">{reason}</span>
                                            </label>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="OrderIssuePopupFooter">
                            <button
                                type="button"
                                className="OrderIssuePopupSubmit"
                                onClick={handleReasonSubmit}
                                disabled={!selectedReason || submitting}
                            >
                                {submitting ? 'SUBMITTING...' : 'SUBMIT'}
                            </button>
                        </div>
                    </>
                ) : null}

                {step === 'confirm' ? (
                    <>
                        <div className="OrderIssuePopupBody OrderIssuePopupBody--flush">
                            <OrderIssueProductSummary products={selectedProducts} />
                            <div className="OrderIssuePopupConfirm">
                                <div className="OrderIssuePopupConfirmTitle">{confirmTitle}</div>
                                <p className="OrderIssuePopupConfirmText">
                                    We&apos;ve noted down your request. We&apos;ll get in touch with you in the next 24 hours.
                                </p>
                            </div>
                        </div>
                        <div className="OrderIssuePopupFooter">
                            <button
                                type="button"
                                className="OrderIssuePopupSubmit"
                                onClick={onClose}
                            >
                                BACK TO MY ORDERS
                            </button>
                        </div>
                    </>
                ) : null}
            </div>
        </Modal>
    );
}

function OrderCard({ data, onHaveIssue }) {
    const navigate = useNavigate();
    const orderValue = formatPrice(data.total_amount, { showSymbol: false });
    const products = Array.isArray(data.productslist) ? data.productslist : [];

    return (
        <div className="OrderHistoryCard">
            <div className="OrderHistoryCardHeader">
                <div className="OrderHistoryMeta">
                    <div className="OrderHistoryMetaBlock">
                        <div className="OrderHistoryMetaLabel">{formatOrderDate(data.created_at)}</div>
                        <div className="OrderHistoryMetaValue">ORDER ID : {data.order_number}</div>
                    </div>
                    <div className="OrderHistoryMetaBlock">
                        <div className="OrderHistoryMetaLabel">ORDER VALUE</div>
                        <div className="OrderHistoryMetaValue">₹ {orderValue}</div>
                    </div>
                </div>
                <div className="OrderHistoryActions">
                    <button
                        type="button"
                        className="OrderHistoryActionBtn"
                        onClick={() => onHaveIssue(data)}
                    >
                        HAVE AN ISSUE?
                    </button>
                    <button
                        type="button"
                        className="OrderHistoryActionBtn"
                        onClick={() => navigate(`/orderdetails/${data.id}`)}
                    >
                        VIEW DETAILS
                    </button>
                    {data.invoice_file ? (
                        <a
                            href={data.invoice_file}
                            target="_blank"
                            rel="noreferrer"
                            className="OrderHistoryActionBtn"
                        >
                            VIEW INVOICE
                        </a>
                    ) : (
                        <button type="button" className="OrderHistoryActionBtn" disabled>
                            VIEW INVOICE
                        </button>
                    )}
                </div>
            </div>

            <div className="OrderHistoryProducts">
                {products.map((product, pindex) => (
                    <div className="OrderHistoryProductRow" key={`${data.order_number || 'order'}-${product.product_id || pindex}`}>
                        <Link
                            to={`/products/productdetails/${product.product_id}`}
                            className="OrderHistoryThumb"
                        >
                            <img
                                src={getProductImage(product)}
                                alt={product.product_title || 'Product'}
                            />
                        </Link>
                        <div className="OrderHistoryDetails">
                            <div className="OrderHistoryColLabel">ORDER DETAILS</div>
                            <div className="OrderHistoryBrand">{product.product_title}</div>
                            {product.sku ? (
                                <div className="OrderHistoryLine">CODE : {product.sku}</div>
                            ) : null}
                            {product.size ? (
                                <div className="OrderHistoryLine">SIZE : {product.size}</div>
                            ) : null}
                        </div>
                        <div className="OrderHistoryPriceCol">
                            <div className="OrderHistoryColLabel">PRICE</div>
                            <div className="OrderHistoryColValue">
                                ₹ {formatPrice(
                                    product.saleprice > 0 ? product.saleprice : product.price,
                                    { showSymbol: false }
                                )}
                            </div>
                        </div>
                        <div className="OrderHistoryStatusCol">
                            <div className="OrderHistoryColLabel">STATUS</div>
                            <div className="OrderHistoryColValue">{getProductListStatus(product)}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

function EmptyOrders() {
    return (
        <div className="layout column justify-space-between align-center m-t-48 m-b-48">
            <div className="NoStateImage m-b-16">
                <div className="DynamicHeightLoaderWrapper icon" style={{ paddingTop: '100%' }}>
                    <div className="DynamicHeightLoader layout row align-center justify-center">
                        <img src={Noorderhistory} alt="logo" className="img-resp DynamicHeightLoaderImage" />
                    </div>
                </div>
            </div>
            <h1 className="h1 demi-bold m-b-8">Your closet is empty!</h1>
            <p className="p1 demi-bold m-b-25">Let’s do some shopping.</p>
            <Link to="/" className="btn-orat-secondry width-auto text-uppercase">start shopping</Link>
        </div>
    );
}

function OrderList({ orderArr, onHaveIssue }) {
    if (!orderArr || orderArr.length === 0) {
        return <EmptyOrders />;
    }

    return (
        <div className="OrderHistoryList">
            {orderArr.map((data, index) => (
                <OrderCard
                    data={data}
                    key={data.order_number || index}
                    onHaveIssue={onHaveIssue}
                />
            ))}
        </div>
    );
}

function Orderhistory() {
    const navigate = useNavigate();
    const userInfo = useSelector((state) => state.user.userInfo);
    const [orderArr, setOrderArr] = useState([]);
    const [loading, setLoading] = useState(true);
    const [issueOrder, setIssueOrder] = useState(null);
    const dispatch = useDispatch();

    const getOrderList = () => {
        const userDetails = {
            user_id: userInfo?.data?.user?.id
        };

        orderhistory(userDetails)
            .then((data) => {
                setOrderArr(Array.isArray(data?.data) ? data.data : []);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching order list:", error);
                setLoading(false);
            });
    };

    const handleLogout = () => {
        dispatch(logout(userInfo));
        navigate('/');
    };

    const handleIssueReported = ({ orderId, productIds = [], giftIds = [], status }) => {
        const productIdSet = new Set(productIds.map((id) => String(id)));
        const giftIdSet = new Set(giftIds.map((id) => String(id)));

        setOrderArr((prev) =>
            prev.map((order) => {
                const currentOrderId = order?.id || order?.order_id;
                if (String(currentOrderId) !== String(orderId)) return order;

                const nextProductslist = Array.isArray(order.productslist)
                    ? order.productslist.map((product) => {
                        const productId = String(product?.product_id || product?.id || '');
                        const giftId = String(product?.gift_id || product?.giftcard_id || '');
                        const shouldUpdate =
                            (productId && productIdSet.has(productId)) ||
                            (giftId && giftIdSet.has(giftId));
                        return shouldUpdate ? { ...product, status } : product;
                    })
                    : order.productslist;

                const updateGiftList = (list) =>
                    Array.isArray(list)
                        ? list.map((gift) => {
                            const giftId = String(gift?.gift_id || gift?.giftcard_id || gift?.id || '');
                            return giftId && giftIdSet.has(giftId) ? { ...gift, status } : gift;
                        })
                        : list;

                return {
                    ...order,
                    productslist: nextProductslist,
                    giftlist: updateGiftList(order.giftlist),
                    gift_list: updateGiftList(order.gift_list),
                    giftcards: updateGiftList(order.giftcards),
                    gifts: updateGiftList(order.gifts),
                };
            })
        );

        setIssueOrder((prev) => {
            if (!prev) return prev;
            const currentOrderId = prev?.id || prev?.order_id;
            if (String(currentOrderId) !== String(orderId)) return prev;

            const nextProductslist = Array.isArray(prev.productslist)
                ? prev.productslist.map((product) => {
                    const productId = String(product?.product_id || product?.id || '');
                    const giftId = String(product?.gift_id || product?.giftcard_id || '');
                    const shouldUpdate =
                        (productId && productIdSet.has(productId)) ||
                        (giftId && giftIdSet.has(giftId));
                    return shouldUpdate ? { ...product, status } : product;
                })
                : prev.productslist;

            return { ...prev, productslist: nextProductslist };
        });
    };

    useEffect(() => {
        if (!userInfo) {
            navigate('/');
        } else {
            getOrderList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigate]);

    return (
        loading ? (
            <Loader />
        ) : (
            <>
                <BrowserView>
                    <div className="App other-page-top my-orderhistory-mobile">
                        <div className="AppContent BreakPointContainer">
                            <div className="MyAccountWrapper prel">
                                <div className="MyAccountHeader layout align-center">
                                    <div className="layout demi-bold justify-start h4 align-center">
                                        <Link to="/myaccount"><span> MY ACCOUNT </span></Link>
                                        <div className="DynamicHeightLoaderWrapper icon">
                                            <FaChevronRight style={{ width: '20px', height: '12px', margin: '0px 8px', color: '#000' }} />
                                        </div>
                                        <span className="demi-bold">MY ORDERS</span>
                                    </div>
                                </div>
                                <div className="MyAccBody layout xs12">
                                    <AccountSidebar onLogout={handleLogout} />
                                    <div className="MyAccountPageWrapper flex xs9 prel">
                                        <div className="OrdersWrap OrderHistoryPanel">
                                            <div className="h4 demi-bold"> MY ORDERS </div>
                                            <OrderList orderArr={orderArr} onHaveIssue={setIssueOrder} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </BrowserView>
                <MobileView>
                    <div className="App other-page-top my-orderhistory-mobile">
                        <div className="AppContent BreakPointContainer container">
                            <div className="MyAccountWrapper prel">
                                <div className="MyAccountHeader layout align-center">
                                    <div className="layout demi-bold justify-start h4 align-center">
                                        <Link to="/myaccount"><span> MY ACCOUNT </span></Link>
                                        <div className="DynamicHeightLoaderWrapper icon">
                                            <FaChevronRight style={{ width: '20px', height: '12px', margin: '0px 8px', color: '#000' }} />
                                        </div>
                                        <span className="demi-bold">MY ORDERS</span>
                                    </div>
                                </div>
                                <div className="MyAccBody">
                                    <div className="MyAccountPageWrapper prel">
                                        <div className="OrdersWrap OrderHistoryPanel">
                                            <div className="h4 demi-bold"> MY ORDERS </div>
                                            <OrderList orderArr={orderArr} onHaveIssue={setIssueOrder} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </MobileView>
                <OrderIssuePopup
                    show={!!issueOrder}
                    order={issueOrder}
                    onClose={() => setIssueOrder(null)}
                    onIssueReported={handleIssueReported}
                />
                <Footer />
            </>
        )
    );
}

export default Orderhistory;
